import { isNil } from "@hopper-ui/components";
import { MixpanelEventName, MixpanelProperty } from "@sg-protect/shell";
import type { DOMEventTelemetryHandler } from "./domEventTracker.ts";
import { getClosestRole, getModalInformation, getRole, getTelemetryName } from "./utils.ts";

export const buttonClickHandler: DOMEventTelemetryHandler<"click"> = {
    isHandling: evt => {
        if (isNil(evt.target)) {
            return false;
        }

        const element = evt.target as HTMLElement;

        return isButton(element) || actAsAButton(element);
    },
    handleEvent: (evt, onEvent) => {
        const target = evt.target as HTMLElement;
        const { event, name, modal } = isButton(target)
            ? getTelemetryPropertiesForButton(target.closest("button")!)
            : getTelemetryPropertiesForRoleButton(getClosestRole(target, "button"));

        void onEvent(event, {
            [MixpanelProperty.Name]: name,
            [MixpanelProperty.Modal]: modal
        });
    }
};

const isButton = (element: HTMLElement) => {
    return !!element.closest("button");
};

const actAsAButton = (element: HTMLElement) => {
    return !!getClosestRole(element, "button");
};

const getTelemetryPropertiesForButton = (button: HTMLButtonElement) => {
    return {
        event: getRole(button) === "tab" ? MixpanelEventName.TabChanged : MixpanelEventName.ButtonClicked,
        name: getTelemetryName(button),
        modal: getModalInformation(button)
    };
};

const getTelemetryPropertiesForRoleButton = (element: HTMLElement) => {
    return {
        event: MixpanelEventName.ButtonClicked,
        name: getTelemetryName(element),
        modal: getModalInformation(element)
    };
};
